<template>
    <div>
        <el-card class="box-card mb15" >
            <h4>预约信息</h4>
              <el-form ref="rowData" label-width="120px" :model="rowData" :rules="rules"><!--这里的model要用:model不然表单验证失效-->
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="设备名称:" prop="equipmentName">
                      <el-input v-model="rowData.equipmentName" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="房间名称:" prop="roomName">
                      <el-input v-model="rowData.roomName" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="地理位置:" prop="geographicalPosition">
                      <el-input v-model="rowData.geographicalPosition" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="负责人/管理员:" prop="person">
                      <el-input v-model="rowData.person" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>   
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="价格:" prop="price">
                        <el-input v-model="rowData.price" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="供应商:" prop="supplier">
                        <el-input v-model="rowData.supplier" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="品牌/规格型号:" prop="model">
                      <el-input v-model="rowData.model" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="入库日期:" prop="warehousingTime">
                      <el-input v-model="rowData.warehousingTime" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="质保期:" prop="warrantyPeriod">
                      <el-input v-model="rowData.warrantyPeriod" placeholder="请输入内容" :disabled="isDetails"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="创建人:" prop="reserve1">
                      <el-input v-model="rowData.reserve1" placeholder="请输入内容" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>          
            </el-form>
     </el-card>
     <div slot="footer" class="dialog-footer bottomButton">
        <el-button type="primary" plain @click="examineSubmit('rowData')" v-show="!isDetails">提 交</el-button>
        <el-button type="primary" plain @click="goBack()">返 回</el-button>
     </div>
    </div>
</template>
<script>
import {
  tbSharedQueryById,
  tbSharedAdd,
} from "@/api/shared";
import { getItem } from "@/utils/session";

export default {
    created(){
        let userinfo= JSON.parse(getItem("userinfo")); 
        this.rowData.reserve1 = userinfo.username;
        if(this.$route.query.rowId){
            this.getList(this.$route.query.rowId);
        }
        if(this.$route.query.type == '2'){
            this.isDetails = true;
        }else{
            this.isDetails = false;
        }
    },
    data(){
        return{
            type:this.$route.query.type,
            rowId:this.$route.query.rowId,
            isDetails:false,
            rowData:{},
            rules:{
              equipmentName:[
                { required: true, message: "请输入名称", trigger: "blur" },
              ],
            },
            pageObj: {},
        }
    },
    methods:{
        //查询数据
        getList(id){
            tbSharedQueryById(id).then(res=>{
                this.rowData = res.data.data[0];
            });
        },
        //提交保存
        examineSubmit(){
          this.$refs['rowData'].validate((valid) => {
            if (valid) {
              const loading = this.openLoading();
              tbSharedAdd(this.rowData).then(res=>{
                if(res.data.code == 0){
                  this.$message.success(res.data.msg);
                            this.goBack();
                }else{
                  this.$message.error(res.data.msg);
                }
                loading.close();
              });
            }
          });

            
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
    }
}
</script>